"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./styles.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function col(_ref) {
  var xm = _ref.xm,
      sm = _ref.sm,
      md = _ref.md,
      lg = _ref.lg,
      size = _ref.size,
      className = _ref.className,
      styles = _ref.styles,
      children = _ref.children;
  var colClass = [];

  if (size) {
    colClass.push("col-".concat(size));
  }

  if (xm) {
    colClass.push("col-xm-".concat(xm));
  }

  if (sm) {
    colClass.push("col-sm-".concat(sm));
  }

  if (md) {
    colClass.push("col-md-".concat(md));
  }

  if (lg) {
    colClass.push("col-lg-".concat(lg));
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)("col", className, colClass),
    style: styles
  }, children);
}

col.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),
  size: _propTypes.default.number,
  xm: _propTypes.default.number,
  sm: _propTypes.default.number,
  md: _propTypes.default.number,
  lg: _propTypes.default.number,
  styles: _propTypes.default.string,
  className: _propTypes.default.string
};
var _default = col;
exports.default = _default;